// extracted by mini-css-extract-plugin
export var growableInput = "_5v-0";
export var tagContainer = "_5v-2";
export var textInput = "_5v-1";